import * as React from 'react';

import './TagWell.scss';

import { ITagPlateSample } from '@models';

export interface ITagWellStateProps
  extends Pick<ITagPlateSample, 'displayColor'>,
    Pick<ITagPlateSample, 'externalSubjectId'> {
  selected: boolean;
  character?: string;
}

export interface ITagWellDispatchProps {
  onClick: () => void;
}

const Flowcell: React.FC<ITagWellStateProps & ITagWellDispatchProps> = ({
  displayColor: color,
  character,
  onClick,
  selected,
}) => {
  return (
    <div className={`flowcell ${selected && 'selected'}`}>
      <div onClick={onClick} style={{ backgroundColor: color }}>
        {!!character && <div>{character}</div>}
      </div>
    </div>
  );
};

export default Flowcell;
